import { Controller } from 'stimulus';
import NoSleep from 'nosleep.js';

export default class extends Controller {

  connect() {
    this.noSleep = new NoSleep();
    this.enabled = false;
    this.update();
  }

  disconnect() {
    this.disable();
  }

  enable() {
    if (this.enabled) return;

    this.enabled = true;
    this.noSleep.enable();
    this.update();
  }

  disable() {
    if (!this.enabled) return;

    this.enabled = false;
    this.noSleep.disable();
    this.update();
  }

  update() {
    this.element.classList.toggle('wakelock-enabled', this.enabled);
    this.element.classList.toggle('wakelock-disabled', !this.enabled);
  }
}
